import React from "react";
import PropTypes from "prop-types";
import { Flex, Text, Box, Dropdown, DateRangePicker } from "samba-ui";
import styled from "styled-components";

export const dropDownOptions = [
  { label: "Custom Range", value: "custom" },
  { label: "Current week", value: { unit: "week", frame: "current" } },
  { label: "Last week", value: { unit: "week", frame: "last" } },
  { label: "Current month", value: { unit: "month", frame: "current" } },
  { label: "All Dates", value: null },
  { label: "365 Days", value: { days: 365 } },
  { label: "180 Days", value: { days: 180 } },
  { label: "90 Days", value: { days: 90 } },
  { label: "60 Days", value: { days: 60 } },
  { label: "30 Days", value: { days: 30 } },
  { label: "14 Days", value: { days: 14 } },
  { label: "7 Days", value: { days: 7 } },
  { label: "3 Days", value: { days: 3 } },
  { label: "1 Days", value: { days: 1 } }
];

export const getSelectedDateRangeByValue = value => {
  return dropDownOptions.find(
    option => JSON.stringify(option.value) === JSON.stringify(value)
  );
};

const ReactDatePickerWrapper = styled(Box)`
  .react-datepicker__input-container {
    position: relative;
    display: inline-block;
    width: 290px;
    margin-right: 8px;

    &.react-datepicker__tether-enabled {
      &:before {
        color: rgba(69, 119, 237, 0.8);
      }
    }
  }

  .react-datepicker__input-container:before {
    right: 8px !important;
    top: 10px !important;
  }

  button.react-datepicker__navigation {
    background: none;
    line-height: 1.7rem;
    text-align: center;
    cursor: pointer;
    position: absolute;
    top: 10px;
    width: 0;
    padding: 0;
    border: 0.45rem solid transparent;
    z-index: 1;
    height: 10px;
    width: 10px;
    text-indent: -999em;
    overflow: hidden;
  }

  .react-datepicker__navigation--previous {
    border-right-color: rgba(69, 119, 237, 0.8) !important;
    left: 10px;
  }

  .react-datepicker__navigation--next {
    border-left-color: rgba(69, 119, 237, 0.8) !important;
    right: 10px;
  }
`;

const SetDateRange = ({
  onChooseDate,
  startDate,
  endDate,
  selectedOption = { label: "All Dates", value: null },
  setSelectedOption
}) => {
  return (
    <Box>
      <Flex my={2} alignItems="center" justifyContent="space-between">
        <Text>Default Date Range Filter:</Text>
        <Box mb={2} width={300}>
          <Dropdown
            options={dropDownOptions}
            selected={selectedOption}
            onSelect={setSelectedOption}
          />
        </Box>
      </Flex>
      {selectedOption && selectedOption.value === "custom" ? (
        <Flex justifyContent="flex-end" mb={3}>
          <ReactDatePickerWrapper>
            <DateRangePicker
              minStartDate={null}
              onChooseDate={onChooseDate}
              startDate={startDate}
              endDate={endDate}
            />
          </ReactDatePickerWrapper>
        </Flex>
      ) : null}
    </Box>
  );
};

SetDateRange.propTypes = {
  onChooseDate: PropTypes.func,
  startDate: PropTypes.object,
  endDate: PropTypes.object,
  selectedOption: PropTypes.object,
  setSelectedOption: PropTypes.func
};

export default SetDateRange;
